import {getMandarkURL, getOrigin} from '@albert-io/environment';
import {getSession} from '@albert-io/mandark/authentication';

import {storePostLoginRedirect} from 'lib/postLoginRedirect';
import {local} from 'lib/StorageUtil';

export const GOOGLE_CLASSROOM_ASSIGNMENTS_FLAG = 'google_classroom_assignments';

const consentMarkerKey = (): string => `googleClassroomOfflineConsent:${getSession().getId()}`;

/**
 * Whether this user has been sent through the offline-consent flow. Set before redirecting: an
 * abandoned consent screen falls back to the plain Google sign-in, and the backend surfaces
 * `not_connected` when grade passback needs the missing token.
 */
export function hasRequestedGoogleClassroomConsent(): boolean {
  return !!local.get(consentMarkerKey());
}

/**
 * Sends the teacher through the backend's Google consent flow for the Classroom scopes
 * (`classroom=true`); `SocialLanding` returns them to the current page afterwards.
 */
export function startGoogleClassroomConsent(): void {
  local.set(consentMarkerKey(), true);
  storePostLoginRedirect(`${window.location.pathname}${window.location.search}`);
  window.location.assign(
    getMandarkURL(
      `/auth/google?${new URLSearchParams({classroom: 'true', redirect_host: getOrigin()})}`
    )
  );
}
